import React from 'react';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon, LockIcon, MailIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function PricingSection() {
  const {
    minutes,
    seconds,
    isUrgent
  } = useCountdown(15);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  const checkoutUrl = 'https://checkout.guiadigital360.online/cart/44005388255301:1';
  return <section id="compra" className="py-12 md:py-24 px-4 bg-brand-light scroll-mt-10" data-id="element-200">
      <div className="max-w-3xl mx-auto" data-id="element-201">
        <div className="text-center mb-10" data-id="element-202">
          <h2 className="text-4xl md:text-5xl font-black text-brand-dark mb-4" data-id="element-203">
            Precio de relanzamiento
          </h2>
          <div className={`inline-flex items-center gap-2 bg-red-100 text-red-700 font-bold px-4 py-2 rounded-full ${isUrgent ? 'animate-pulse' : ''}`} data-id="element-204">
            <span data-id="element-205">⏱️</span>
            <span data-id="element-206">
              Termina en: {formatTime(minutes)}:{formatTime(seconds)}
            </span>
          </div>
        </div>

        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl border-4 border-brand-orange relative text-center" data-id="element-207">
          <div className="text-gray-400 text-2xl line-through font-bold mb-2" data-id="element-208">
            Antes: $49.900 ARS
          </div>
          <div className="text-5xl md:text-7xl font-black text-brand-dark mb-8" data-id="element-209">
            HOY: <span className="text-brand-orange" data-id="element-210">$19.990</span>{' '}
            <span className="text-3xl" data-id="element-211">ARS</span>
          </div>

          <h3 className="text-2xl font-bold text-brand-blue mb-6 border-b pb-4" data-id="element-212">
            Todo incluido:
          </h3>

          <ul className="text-gray-700 text-lg mb-10 space-y-4 text-left max-w-md mx-auto" data-id="element-213">
            <li className="flex items-start gap-3" data-id="element-214">
              <span className="text-brand-green" data-id="element-215">✅</span>
              <span className="font-medium" data-id="element-216">
                +1000 actividades (PDF imprimible)
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-217">
              <span className="text-brand-green" data-id="element-218">✅</span>
              <span className="font-medium" data-id="element-219">
                Cuadernillos por área y por edad
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-220">
              <span className="text-brand-green" data-id="element-221">✅</span>
              <span className="font-medium" data-id="element-222">+60 planillas editables</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-223">
              <span className="text-brand-green" data-id="element-224">✅</span>
              <span className="font-medium" data-id="element-225">
                Rutinas visuales y pictogramas
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-226">
              <span className="text-brand-green" data-id="element-227">✅</span>
              <span className="font-medium" data-id="element-228">
                Material para TEA • TDAH • Dislexia • Lenguaje
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-229">
              <span className="text-brand-green" data-id="element-230">✅</span>
              <span className="font-medium" data-id="element-231">
                4 bonos incluidos sin costo extra
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-232">
              <span className="text-brand-green" data-id="element-233">✅</span>
              <span className="font-medium" data-id="element-234">Acceso inmediato por email</span>
            </li>
          </ul>

          <div className="max-w-md mx-auto mb-6" data-id="element-235">
            <CTAButton text="SÍ, QUIERO EL PACK + LOS BONOS →" href={checkoutUrl} isLink={true} className="py-5 text-xl" data-id="element-236" />
          </div>

          <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 text-sm text-gray-600 font-medium" data-id="element-237">
            <span className="flex items-center gap-2" data-id="element-238">
              <LockIcon className="w-5 h-5 text-gray-400" data-id="element-239" /> Compra segura con
              Mercado Pago
            </span>
            <span className="flex items-center gap-2" data-id="element-240">
              <MailIcon className="w-5 h-5 text-gray-400" data-id="element-241" /> Recibís el acceso
              en minutos
            </span>
            <span className="flex items-center gap-2" data-id="element-242">
              <ShieldCheckIcon className="w-5 h-5 text-brand-green" data-id="element-243" /> Garantía
              total de 7 días
            </span>
          </div>
        </div>
      </div>
    </section>;
}